import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { toast } from 'react-toastify';
import { labRequests } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_LABREQUEST,
  DELETE_LABREQUEST,
  GET_LABREQUEST,
  GET_LABREQUESTS,
  GET_LABREQUESTSREPORTDETAIL,
  UPDATE_LABREQUEST
} from "./actionTypes";
import {
  addLabRequestFail,
  addLabRequestSuccess,
  deleteLabRequestFail,
  deleteLabRequestSuccess,
  getLabRequestsFail,
  getLabRequestsReportDetailFail,
  getLabRequestsReportDetailSuccess,
  getLabRequestsSuccess,
  getLabRequestSuccess,
  setState,
  updateLabRequestFail,
  updateLabRequestSuccess,
} from "./actions";

//Include Both Helper File with needed methods

function* fetchLabRequests( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable,labRequests, params.toString());
    yield put(setState(false))
    yield put(getLabRequestsSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestsFail(error));
  }
}

function* fetchLabRequestsReportDetail( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable,`${labRequests}/report-details`, params.toString());
    yield put(setState(false))
    yield put(getLabRequestsReportDetailSuccess(response));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestsReportDetailFail(error));
  }
}

function* fetchLabRequestById( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable,labRequests, params.toString());
    yield put(getLabRequestSuccess(response));
    yield put(setState(false))
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestsFail(error));
  }
}

function* updateLabRequest ({payload: labRequestObj }) {
  try {
    const { id, recordStatus, statusOnly, onSuccess, onFail, ...rest } = labRequestObj;
    if (statusOnly) {
      yield call(patchApiCall, `${labRequests}/general-status/${id}`, rest);
    } else {
      yield call(patchApiCall, `${labRequests}/${id}`, rest);
    }
    const response = yield call(getTable,`${labRequests}/${labRequestObj.id}`);
    // console.log('OBJETO actualizado:', response)
    yield put(updateLabRequestSuccess(response));
    toast.success('Registro actualizado correctamente');
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(updateLabRequestFail(error));
    toast.error('Error al actualizar el registro');
    const { onFail } = labRequestObj;
    if (onFail) onFail();
  }
}

function* deleteLabRequest ({payload: labRequestObj}) {
  try {
    yield call(deleteApiCall, `${labRequests}/${labRequestObj.id}`);
    yield put(deleteLabRequestSuccess(labRequestObj.id));
    toast.success('Registro borrado correctamente')
  } catch (error) {
    yield put(deleteLabRequestFail(error));
    toast.error('Error al borrar el registro')
  }
}

function* postingLabRequest ({ payload: labRequest}) {
  try {
    const response = yield call(postApiCall, labRequests ,labRequest);
    const response2 = yield call(getTable,`${labRequests}/${response.id}`);
    yield put(addLabRequestSuccess(response2));
    toast.success('Registro agregado correctamente')
    } catch (error) {
    yield put(addLabRequestFail(error));
    toast.error('Error al agregar el registro')
  }
}

function* labRequestsSaga() {
  yield takeEvery(GET_LABREQUESTS, fetchLabRequests);
  yield takeEvery(GET_LABREQUESTSREPORTDETAIL , fetchLabRequestsReportDetail)
  yield takeEvery(ADD_NEW_LABREQUEST, postingLabRequest);
  yield takeEvery(UPDATE_LABREQUEST, updateLabRequest);
  yield takeEvery(DELETE_LABREQUEST, deleteLabRequest);
  yield takeEvery(GET_LABREQUEST, fetchLabRequestById);
}

export default labRequestsSaga;
